import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { DocumentUploadService } from '@xengage/gw-portals-document-js';


export default class WniMicroFrontendService {

    static getSubmissionIntakeAvailableProducts(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('wniSubmissionIntake'), 'getAvailableProducts',[], additionalHeaders);
    }

    static getAcordReviewUrl(file, documentMetadata, additionalHeaders) {
        return DocumentUploadService.send(getProxiedServiceUrl('wniSubmissionIntake'), file, documentMetadata, additionalHeaders);
    }

    static getLossRunReviewUrl(file, documentMetadata, additionalHeaders) {
        return DocumentUploadService.send(getProxiedServiceUrl('wniLossRun'), file, documentMetadata, additionalHeaders);
    }
    
}